<div class="form-group"
     [class.clearfix]="blocksConfig.validation && block.settings.validate && block.settings.maxLength">
  <pl-readonly-indicator *ngIf="block.settings.hide_name && block.settings.readonly && blocksConfig.editable" />

  <label *ngIf="!block.settings.hide_name" [for]="domId + slug">
    <span [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedName(currentContentLocale, originalContentLocale)">
      {{block.localizedName(currentContentLocale, originalContentLocale, true)}}
    </span>
    <pl-required-indicator *ngIf="block.settings.required && blocksConfig.showRequiredIndicator && !ineligible" />
    <pl-readonly-indicator *ngIf="block.settings.readonly && blocksConfig.editable" />
  </label>

  <input *ngIf="block.settings.multiline !== true && (blocksConfig.editable || blocksConfig.submittable)"
         #input="ngModel"
         [class.empty]="!input.value"
         [class.is-invalid]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required)  && (input?.invalid || !this.lengthOkay) && input?.touched"
         [class.is-valid]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required) && input?.dirty && (input?.valid && this.lengthOkay)"
         [class.p-0]="!block.settings.padding"
         [fontSizeEnabled]="isOverlay || block.settings.fontSize!==16"
         [fontSize]="block.settings.fontSize"
         [gizmoDestinationInput]="input.control"
         [gizmoDestination]="this"
         [id]="domId + slug"
         [name]="slug || block.local_uuid || ''+block.id"
         [ngClass]="'slug_' + slug"
         [ngModel]="data"
         (ngModelChange)="setValue($event)"
         [pattern]="block.settings.validate ? block.regex : null"
         [placeholder]="getPlaceholder()"
         [class.placeholder-danger]="getPlaceholderDanger()"
         [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
         [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable)"
         [required]="block.settings.required && !blocksConfig.preview"
         [style.padding-bottom.px]="block.settings.paddingY"
         [style.padding-left.px]="block.settings.paddingX"
         [style.padding-right.px]="block.settings.paddingX"
         [style.padding-top.px]="block.settings.paddingY"
         [type]="block.inputType"
         [attr.aria-describedby]="domId + slug + 'helptext'"
         class="form-control">

  <textarea *ngIf="block.settings.multiline === true && (blocksConfig.editable || blocksConfig.submittable)"
            #input="ngModel"
            [autosize]="!isOverlay"
            [class.empty]="!input.value"
            [class.h-100]="isOverlay"
            [class.is-invalid]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required)  && (input?.invalid || !this.lengthOkay) && input?.touched"
            [class.is-valid]="(!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required) && input?.dirty && (input?.valid && this.lengthOkay)"
            [class.p-0]="!block.settings.padding"
            [fontSizeEnabled]="isOverlay || block.settings.fontSize !== 16"
            [fontSize]="block.settings.fontSize"
            [gizmoDestinationInput]="input"
            [gizmoDestination]="this"
            [id]="domId + slug"
            [name]="slug || block.local_uuid || ''+block.id"
            [ngClass]="'slug_' + slug"
            [ngModel]="data"
            (ngModelChange)="setValue($event)"
            [pattern]="block.settings.validate ? block.regex : null"
            [placeholder]="getPlaceholder()"
            [class.placeholder-danger]="getPlaceholderDanger()"
            [disabled]="ineligible || (block.settings.readonly && blocksConfig.submittable && !blocksConfig.editable)"
            [readonly]="(block.settings.readonly && !blocksConfig.editable) || (!blocksConfig.editable && !blocksConfig.submittable)"
            [required]="block.settings.required && !blocksConfig.preview"
            [style.padding-bottom.px]="block.settings.paddingY"
            [style.padding-left.px]="block.settings.paddingX"
            [style.padding-right.px]="block.settings.paddingX"
            [style.padding-top.px]="block.settings.paddingY"
            [attr.aria-describedby]="domId + slug + 'helptext'"
            class="form-control">
  </textarea>

  <p *ngIf="!blocksConfig.editable && !blocksConfig.submittable"
     [class.form-control-overlay]="isOverlay"
     [class.form-control]="!isOverlay"
     [class.multiline]="block.settings.multiline === true"
     [class.print-optimized]="blocksConfig.printOptimized"
     [class.p-0]="!block.settings.padding"
     [fontSizeEnabled]="isOverlay || block.settings.fontSize !== 16"
     [fontSize]="block.settings.fontSize"
     [id]="domId + slug"
     [style.padding-bottom.px]="block.settings.paddingY"
     [style.padding-left.px]="block.settings.paddingX"
     [style.padding-right.px]="block.settings.paddingX"
     [style.padding-top.px]="block.settings.paddingY">

    <b *ngIf="block.settings.hide_name && data && !isOverlay">{{block.settings.name}}: </b> {{data}}

    <span *ngIf="!data && !blocksConfig.printOptimized" class="placeholder">{{getPlaceholder()}}</span>
  </p>

  <small *ngIf="blocksConfig.validation && block.settings.validate && block.settings.maxLength"
         [class.text-danger]="data?.length > block.settings.maxLength"
         class="float-right mr-0 mt-1 pl-3 text-muted">
    {{data?.length ?? 0}}/{{block.settings.maxLength}}
  </small>

  <div
    *ngIf="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && (block.settings.validate || block.settings.required) && !!input?.invalid && !!input?.touched"
    class="text-danger">
    <ng-container *transloco="let t; read: 'blocks.' + block.type + '.errors'">

      <div *ngIf="input?.errors.required">
        {{t('required')}}
      </div>

      <ng-container *ngIf="block.settings.validate">
        <div *ngIf="!input?.errors.required && block.settings.type === InputType.zip">
          {{t('zip')}}
        </div>

        <div *ngIf="!input?.errors.required && block.settings.type === InputType.vat_id">
          {{t('vat_id')}}
        </div>

        <div *ngIf="!input?.errors.required && block.settings.type === InputType.email">
          {{t('email')}}
        </div>
      </ng-container>
    </ng-container>
  </div>

  <div
    *ngIf="(!blocksConfig.editable || blocksConfig.preview) && blocksConfig.validation && (block.settings.validate || block.settings.required) && !lengthOkay && !!input?.touched"
    class="text-danger">
    <ng-container *transloco="let t; read: 'blocks.' + block.type + '.errors'">
      <div *ngIf="data?.length < block.settings.minLength">
        {{t('minLength', {maxLength: block.settings.minLength})}}
      </div>

      <div *ngIf="data?.length > block.settings.maxLength">
        {{t('maxLength', {maxLength: block.settings.maxLength})}}
      </div>
    </ng-container>
  </div>

  <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
         [id]="domId + slug + 'helptext'"
         [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
         class="form-text text-muted" aria-hidden="true">
    {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
  </small>
</div>

<pl-ineligibility-overlay *ngIf="ineligible"></pl-ineligibility-overlay>
